import { MigrationSpec } from "../migration.models"

const callSnapshotStartedInWH: MigrationSpec = {
  type: "BACKFILL_CALL_SNAPSHOT_STARTED_IN_WH",
  collection: "CallSnapshots",
  risk: "SAFE",
  title: {
    en: "Call reports: working-hours flag for calls before October 2026",
    tr: "Çağrı raporları: Ekim 2026 öncesi çağrılara mesai bilgisi"
  },
  description: {
    en:
      "Call snapshots written before `startedInWH` existed have no value, so the report filter " +
      "“Started in working hours” — in and out alike — drops every one of those calls from every " +
      "metric. For each snapshot without the key it rebuilds the snapshot from its CallHistories " +
      "row exactly as the live sync does (which also fixes a snapshot that a direct CallHistories " +
      "migration left with a stale status) and sets `startedInWH` from the customer's default " +
      "working-hours schedule at the call's `createdAt`, or null when the customer has no " +
      "schedule. A snapshot whose history row is gone only gets `startedInWH`. A row the live sync " +
      "rewrote meanwhile is skipped: its `updatedAt` changed, and the live value wins.",
    tr:
      "`startedInWH` eklenmeden önce yazılmış çağrı snapshot'larında bu değer yok; bu yüzden " +
      "raporun “Started in working hours” filtresi — mesai içi de mesai dışı da — bu çağrıların " +
      "hepsini her metrikten düşürüyor. Değeri olmayan her snapshot'ı CallHistories satırından, " +
      "canlı senkronun yaptığı gibi yeniden kurar (doğrudan CallHistories'e yazan bir migration'ın " +
      "eski statüde bıraktığı snapshot'lar da böylece düzelir) ve `startedInWH` değerini müşterinin " +
      "varsayılan mesai takvimine göre çağrının `createdAt` anına göre yazar; takvimi olmayan " +
      "müşteride null yazar. Kaynak satırı silinmiş snapshot yalnızca `startedInWH` alır. Bu arada " +
      "canlı senkronun yeniden yazdığı satır atlanır: `updatedAt` değişmiştir, canlı değer kazanır."
  },
  // Copied literally from CALL_SNAPSHOT_STARTED_IN_WH_MISSING_FILTER in api-v2's
  // Statistics/core/callSnapshot.constants.ts.
  affectedFilter: { startedInWH: { $exists: false } },
  sampleFields: [
    "customerId",
    "createdAt",
    "direction",
    "status",
    "startedInWH"
  ],
  preview: (doc) => ({
    ...doc,
    startedInWH:
      "true / false from the customer's default schedule at createdAt, null without one"
  }),
  notes: [
    {
      en:
        "It uses the customer's CURRENT default schedule, not the one in force when the call " +
        "happened; the live sync has always done the same.",
      tr:
        "Müşterinin çağrı anındaki değil ŞU ANKİ varsayılan takvimi kullanılır; canlı senkron da " +
        "hep böyle çalıştı."
    },
    {
      en:
        "A customer whose schedule lookup fails is skipped and stays counted here; the run result " +
        "reports it as `scheduleLookupFailed`. Running it again finishes the rest.",
      tr:
        "Takvimi okunamayan müşteri atlanır ve burada sayılmaya devam eder; çalıştırma sonucu bunu " +
        "`scheduleLookupFailed` olarak bildirir. Yeniden çalıştırmak kalanı tamamlar."
    },
    {
      en:
        "The probe counts across the whole collection on an unindexed key; on a large " +
        "CallSnapshots collection it can hit the 10 s probe timeout and show UNKNOWN.",
      tr:
        "Probe, indekssiz bir alan üzerinden tüm koleksiyonu sayar; büyük bir CallSnapshots " +
        "koleksiyonunda 10 sn'lik probe süresini aşıp UNKNOWN gösterebilir."
    }
  ]
}

export default callSnapshotStartedInWH
